/**
 * WhatsApp Icon Component
 * Lightweight branded icon for WhatsApp actions.
 */
export function WhatsAppIcon({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M12 2.5C6.753 2.5 2.5 6.676 2.5 11.828C2.5 13.617 3.015 15.352 3.99 16.854L2.734 21.5L7.523 20.278C8.96 21.166 10.616 21.635 12.31 21.635C17.557 21.635 21.81 17.459 21.81 12.307C21.81 7.155 17.557 2.5 12.31 2.5H12Z"
        fill="#25D366"
      />
      <path
        d="M17.092 14.778C16.88 15.359 15.847 15.888 15.35 15.959C14.924 16.017 14.386 16.042 12.463 15.257C10.005 14.255 8.429 11.767 8.307 11.607C8.191 11.446 7.311 10.266 7.311 9.045C7.311 7.823 7.947 7.229 8.173 7C8.398 6.772 8.665 6.714 8.837 6.714C9.009 6.714 9.181 6.716 9.328 6.723C9.486 6.73 9.698 6.663 9.88 7.091C10.092 7.596 10.601 8.818 10.667 8.954C10.732 9.09 10.776 9.251 10.684 9.412C10.597 9.573 10.553 9.672 10.423 9.832C10.294 9.993 10.153 10.191 10.038 10.319C9.908 10.462 9.773 10.617 9.918 10.864C10.063 11.111 10.565 11.923 11.298 12.571C12.24 13.401 13.04 13.659 13.303 13.771C13.566 13.882 13.719 13.864 13.869 13.703C14.019 13.542 14.518 12.961 14.693 12.713C14.868 12.466 15.043 12.507 15.275 12.594C15.507 12.681 16.744 13.283 17.005 13.412C17.267 13.542 17.44 13.606 17.493 13.694C17.545 13.782 17.545 14.197 17.092 14.778Z"
        fill="white"
      />
    </svg>
  );
}

export default WhatsAppIcon;
